<script>
import LandingPageMixin from '@/mixins/landingpage'

export default {
  name: 'LandingPageBrendanVacations',
  mixins: [LandingPageMixin],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      modal: 0
    }
  },
  methods: {
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
        document.body.classList.add(
          'modal-open',
          this.isModalTermsAndConditionsToggle
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>

<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right"
    >
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"

      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
          ></span>
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            ></span
          >
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                class="light-logo"
                src="/landingpages/brendan-vacations/img/logo.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>
      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#letter" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('letter')">Description</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('included')">Included</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <main
      class="page-main main-anim scrollpage-container"
      id="mainpage"

    >
      <!--BEGIN  HOME -->
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  firstOpporunityBackgroundImage
                )}')`
              }
            : { backgroundImage: 'url(/landingpages/brendan-vacations/img/bg-style-1.jpg)' }
        ]"
        id="home"
      >
        <div class="overlay-home"></div>
        <div class="section-wrapper">
          <div class="section-content animated fadeInDown slow">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description text-center" >
                  <div class="cover-slider-description">
                   <div class="cover-calendar-location">
                     <h1 class="cover-header-description-title1">
                        <span class="location-cover" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                            <i class="fa fa-map-marker"></i>
                            <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}
                            </span>
                        </span>
                      </h1>
                      <h1 class="cover-header-description-title1">
                            <span>
                                <i class="icon fa fa-calendar"></i>
                                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                                <i class="fa fa-arrow-right ml-3 mr-2"></i>
                            </span>
                            <span class="date-block">
                              <i class="icon fa fa-calendar"></i>
                              <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}
                            </span>
                        </span>
                      </h1>
                    </div>
                    <div class="cover-header-description-title2" v-if="d && d.consumer_section">
                       {{ d.consumer_section.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                        <span>{{ d.consumer_section.trip_subtitle }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOME -->

      <!-- BEING LETTER -->
      <div class="arrow-border"></div>
      <div
        class="section info-area letter_after"
        data-section="letter"
        id="letter"

      >
        <div class="section-wrapper with-margin">
          <div class="single-info row order-mobile">
            <div class="col-lg-12">
              <div class="title-desc title-black">
                <h2 class="h2">Your Celtic Story Starts Here…</h2>
                <img class="dividerLogo" src="/landingpages/brendan-vacations/img/divider.png" />
              </div>
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.consumer_section.short_description">
              </div>
              <div class="tour_host_box text-right px-4" v-if="d.consumer_section.tour_host_photo">
                <img class="tour_host_photo" :src="d.consumer_section.tour_host_photo"/>
                <div class="tour_host_info">
                  <p class="tour_host_name" v-if="d.consumer_section.tour_host_name" v-html="d.consumer_section.tour_host_name"></p>
                  <p v-if="d.consumer_section.tour_host_position" v-html="d.consumer_section.tour_host_position"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END LETTER -->

      <!-- BEING ITINERARY -->
      <div
        class="section grey"
        data-section="itinerary"
        id="itinerary"

      >
        <div class="section-wrapper">
          <div class="section-wrapper">
            <div
              class="col-12 col-lg-12 anim cover-header-description-title2"
            >
              <div class="title-desc title-black">
                <h2 class="h2">Itinerary</h2>
                <img class="dividerLogo" src="/landingpages/brendan-vacations/img/divider.png" />
                <h3 class="text-center title-name-itinerary" v-if="d && d.consumer_section">{{ d.consumer_section.trip_name }}</h3>
              </div>
            </div>

            <div class="row row-random grid-media-aside-text fade-3">
              <div
                class="border-card"
                :class="{
                  'col-md-6':
                    index != Object.keys(d.itineraries.days).length - 1 ||
                    (index === Object.keys(d.itineraries.days).length - 1 &&
                      Object.keys(d.itineraries.days).length % 2 === 0),
                  'col-md-12':
                    index === Object.keys(d.itineraries.days).length - 1 &&
                    Object.keys(d.itineraries.days).length % 2 !== 0
                }"
                v-for="(day, index) in d.itineraries.days"
                :key="index"
                @click="dayScrollTo(index)"
              >
                <div
                  class="card gallery-day"
                  data-toggle="modal"
                  data-target="#modal-fullscreen"
                >
                  <img
                    v-if="day.url_image_1200_725"
                    :src="day.url_image_1200_725"
                  />
                  <img
                    v-if="!day.url_image_1200_725"
                    src="/landingpages/brendan-vacations/img/day-img.jpg"
                  />

                  <div class="info">
                    <div class="text-inside">
                      <h1>DAY {{ day.startday }}</h1>
                      <!-- <span>{{ Object.keys(d.itineraries.days).length % 2 != 0 }}</span> -->
                      <p class="subtittle" v-html="day.title"></p>
                      <p class="date">
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span v-if="day">{{
                          day.startdate | custom-date
                        }}</span>
                      </p>
                      <p class="location">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span
                          v-if="
                            day && day.locations && Array.isArray(day.locations)
                          "
                          >{{ day.locations | custom-join('name') }}</span
                        >
                      </p>
                      <p
                        v-if="
                          day &&
                            day.textday &&
                            day.textday[0] &&
                            day.textday[0].textday
                        "
                      >
                        <span
                          v-html="
                            day.textday[0].textday.substring(0, 250) + '...'
                          "
                        ></span>
                        <a
                          href="javascript:void(0)"
                          data-toggle="modal"
                          class="underlineLink showMoreDay"
                          >Show more</a
                        >
                      </p>

                      <p v-if="day.meals">
                        <strong class="mr-1">MEAL(S):</strong>
                        <span>{{
                          day.meals | custom-join('mealsday')
                        }}</span>
                      </p>
                      <p v-if="day.accommodation">
                        <strong class="mr-1">HOTEL:</strong>
                        <span v-html="day.accommodation"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END ITINERARY -->

      <!-- BEGIN INCLUDED -->
      <div
        class="section fullscreen-md-off no-footer bg-image info-area"
        data-section="included"
        id="included"
        v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0 ||
        Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0"
        :style="[ secondOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  secondOpporunityBackgroundImage
                )}')`
              }
            : { 'background-image': '/landingpages/brendan-vacations/img/bg-style-1.jpg' }
        ]"
      >
          <div class="section-wrapper anim with-margin">
          <div class="section-content anim paddig-container">
          <div class="row">
          <div class="col-12 col-md-12">
            <div class="title-desc title-back">
              <h2 class="h2">Included</h2>
              <img class="mb-4 dividerLogo" src="/landingpages/brendan-vacations/img/divider-white.png" />
            </div>
            <div class="single-info row mt-40">
              <div
                class="col-lg-12 col-md-12 mb-5"
                v-if="
                  Array.isArray(d.consumer_section.highlights) &&
                    d.consumer_section.highlights.length > 0
                "
              >
                  <div class="row m-0 info-content grey">
                    <div class="col-lg-6 col-md-12 p-0">
                      <img
                        v-if="secondOpporunityBackgroundImage != ''"
                        :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                        alt=""
                        class="imgIncluded"
                      />
                      <img
                        v-else
                        src="/landingpages/brendan-vacations/img/highlights.jpg"
                        alt=""
                        class="imgIncluded"
                      />
                    </div>
                    <div class="col-lg-6 col-md-12 px-5 py-4 arrowLeft">
                      <div
                        v-for="highlight in d.consumer_section.highlights"
                        :key="highlight.id"
                      >
                        <p
                          class="pt-3 titleMedium"
                          v-html="highlight.title"
                        ></p>
                        <ul class="mb-4 mt-4">
                          <li v-for="item in highlight.items" :key="item.id">
                            <div v-if="item.items.indexOf(':') == -1">
                              <strong
                                v-if="
                                  item.items.substr(0, item.items.indexOf(' '))
                                "
                                >{{
                                  item.items.substr(0, item.items.indexOf(' '))
                                }}</strong
                              >
                              <span
                                v-if="
                                  item.items.substr(item.items.indexOf(' ') + 1)
                                "
                              >
                                {{
                                  item.items.substr(item.items.indexOf(' ') + 1)
                                }}</span
                              >
                            </div>

                            <div v-else>
                              <span v-if="item.items.split(':').length > 1">
                                <strong v-if="item.items.split(':')[0]"
                                  >{{ item.items.split(':')[0] }}:</strong
                                >
                              </span>
                              <span v-else>{{ item.items.split(':')[0] }}</span>
                              <span v-if="item.items.split(':')[1]">
                                {{ item.items.split(':')[1] }}</span
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
              </div>
              <div
                class="col-lg-12 col-md-12 mb-5"
                v-if="
                  Array.isArray(d.consumer_section.whatsincluded) &&
                    d.consumer_section.whatsincluded.length > 0
                "
              >
                  <div
                    class="row m-0 info-content grey"
                  >
                    <div class="col-lg-6 col-md-6 px-5 py-4 arrowRight">
                      <div
                        v-for="whatsinc in d.consumer_section.whatsincluded"
                        :key="whatsinc.id"
                      >
                        <h3 class="mt-3 titleMedium" v-html="whatsinc.title"></h3>
                        <ul class="mb-4">
                          <li v-for="item in whatsinc.items" :key="item.id">
                            {{ item.items }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12 p-0">
                      <img
                        v-if="secondOpporunityBackgroundImage != ''"
                        :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                        alt=""
                        class="imgIncluded"
                      />
                      <img
                        v-else
                        src="/landingpages/brendan-vacations/img/included.jpg"
                        alt=""
                        class="imgIncluded"
                      />
                    </div>
                  </div>
              </div>
            </div>
          </div>
          </div>
          </div>
          </div>
      </div>
      <!-- END INCLUDED -->

      <!-- BEGIN MAP -->
      <div
        class="section"
        data-section="map"
        id="map"

      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc title-black">
                  <h2 class="h2 anim-2">Map</h2>
                   <img class="mb-4 dividerLogo" src="/landingpages/brendan-vacations/img/divider.png" />
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MAP -->

      <!-- BEGIN PRICES -->
      <div
        class="section fullscreen-md-off no-footer grey "
        data-section="prices"
        id="prices"

      >
        <div class="section-wrapper   with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc title-black">
                  <h2 class="h2 anim-2">Pricing</h2>
                   <img class="mb-4 dividerLogo" src="/landingpages/brendan-vacations/img/divider.png" />
                </div>
                <div>
                  <div class="section-info white table_pricing">
                    <div class="row">
                      <div class="col-12 col-md-6 anim">
                        <div class="text-center" v-if="d && d.consumer_section">
                          <p class="display-5 anim-2 amount-title">Twin Share Price</p>
                          <h2 class="display-5 anim-2 pb-0 amount-price">{{ d.consumer_section.twinshare_price }}</h2>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 anim fluid vl">
                          <div class="text-center" v-if="d && d.consumer_section">
                            <p class="display-5 anim-2 amount-title">Single Supplement Price</p>
                            <h2 class="display-5 anim-2 pb-0 amount-price">{{ d.consumer_section.single_supp_price }}</h2>
                          </div>
                      </div>
                    </div>
                </div>
                </div>
                <p class="terms">
                  View
                  <a href="#" @click.prevent="toggleTermsAndConditionsModal(0)"
                    ><strong>Terms and Conditions</strong></a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END PRICES -->
      <!-- BEGIN CONTACT -->
      <div
        class="section section-contact bg-contact"
        data-section="contact"
        id="contact"

        :style="[ thirdOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  thirdOpporunityBackgroundImage
                )}')`
              }
            : { 'background-image': '/landingpages/brendan-vacations/img/contact.jpg' }
        ]"
      >
        <div class="bg-overlay bg-overlay-contact">
          <div class="section-wrapper with-margin">
            <div class="section-content paddig-container">
              <div class="row">
                <div
                  class="col-12 col-md-6 anim contact-info contact-info-left "
                >
                  <div class="title-desc">
                    <h2 class="display-5 anim-2 text-center">Contact Us</h2>
                  </div>
                  <div class="pt-1 text-center">
                    <p class="pt-4 text-center" v-if="!d.consumer_section && !d.consumer_section.company_logo">
                        Contact your Travel Agent!
                    </p>

                      <p class="pt-4 pb-4 text-center" v-if="!d.consumer_section.call_action">
                        Please send a message.
                      </p>

                      <p v-if="d.consumer_section.call_action" v-html="d.consumer_section.call_action" class="pt-0"></p>
                      <img class="tour_host_logo" v-if="d.consumer_section.company_logo" :src="d.consumer_section.company_logo"/>
                  </div>
                </div>

                <div
                  class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left"
                >
                  <div class="contact-us-box">
                    <div class="title-desc">
                      <h2 class="display-5 anim-2">We’re here to help</h2>
                    </div>
                    <form @submit.prevent="sendContactForm">
                      <div class="form-group ">
                        <input
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="Your Name"
                          v-model="name"
                          :disabled="isSending"
                        />
                      </div>
                      <div class="form-group ">
                        <input
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="Your Email"
                          v-model="email"
                          :disabled="isSending"
                        />
                      </div>
                      <div class="form-group ">
                        <textarea
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="How can we assist you with this group?"
                          cols="10"
                          rows="10"
                          v-model="description"
                          :disabled="isSending"
                        ></textarea>
                      </div>
                      <div
                        class="form-group form-success-gone text-right mb-0 d-flex justify-content-end align-items-center"
                      >
                        <div v-if="isCompleted">{{ message }}</div>
                        <button
                          class="btn btn-outline-white form-success-gone mb-0 ml-2"
                          type="submit"
                          :disabled="isSending"
                        >
                          <strong class="text" v-if="!isSending">Send</strong>
                          <strong class="text" v-else>Sending</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END CONTACT -->

      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br />
            <img src="/landingpages/brendan-vacations/img/logo-itp.png" width="80" />
          </div>
          <div class="detail">
            All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTT fade animated fadeIn show"
      id="modal-terms-and-conditions-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle"
    >
      <div class="overlaymd" @click="toggleTermsAndConditionsModal(modal)"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleTermsAndConditionsModal(modal)"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 titleMedium pt-4 text-center">Terms and Conditions</h3>
            </div>
            <div
              class="title-desc anim-4 paddig-container scrollable"
              v-html="d.consumer_section.terms_conditions"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal modal-fullscreen modalDays fade animated fadeIn show"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/landingpages/brendan-vacations/img/day-img.jpg"
                  />
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1 }}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="location mt-2">
                      <i class="fa fa-map-marker mr-2"></i>
                      <span
                        v-if="
                          day && day.locations && Array.isArray(day.locations)
                        "
                        >{{ day.locations | custom-join('name') }}</span
                      >
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation }}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday">
                    <a class="down" href="#section02">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>